import React, { useState } from "react";
import cn from "classnames";
import styles from "./Settings.module.sass";
import Dropdown from "../../../components/Dropdown";
import Checkbox from "../../../components/Checkbox";

// Options statiques
const sortingOptions = ["Plus récents", "Plus anciens"];
const sectorOptions = ["Informatique", "Commerce", "Industrie", "Services", "BTP", "Santé", "Finance", "Autre"];
const statusOptions = ["Actif", "Inactif"];

const Settings = ({ onFiltersChange }) => {
  // États des filtres
  const [sorting, setSorting] = useState(sortingOptions[0]);
  const [selectedSector, setSelectedSector] = useState("Tous les secteurs");
  const [selectedStatuses, setSelectedStatuses] = useState([]);

  // Gestionnaire pour les statuts
  const handleStatusChange = (status) => {
    const newStatuses = selectedStatuses.includes(status)
      ? selectedStatuses.filter(s => s !== status)
      : [...selectedStatuses, status];
    setSelectedStatuses(newStatuses);
  };

  // Réinitialiser les filtres
  const resetFilters = () => {
    setSorting(sortingOptions[0]);
    setSelectedSector("Tous les secteurs");
    setSelectedStatuses([]);
    
    if (onFiltersChange) {
      onFiltersChange({
        sorting: sortingOptions[0],
        sector: null,
        statuses: []
      });
    }
  };

  // Appliquer les filtres
  const applyFilters = () => {
    const sector = selectedSector !== "Tous les secteurs" ? selectedSector : null;
    
    if (onFiltersChange) {
      onFiltersChange({
        sorting,
        sector,
        statuses: selectedStatuses
      });
    }
  };

  // Préparer les options du dropdown secteurs
  const sectorDropdownOptions = ["Tous les secteurs", ...sectorOptions];

  return (
    <div className={styles.settings}>
      <div className={styles.group}>
        {/* Tri */}
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={sorting}
            setValue={setSorting}
            options={sortingOptions}
            label="Trier par"
          />
        </div>

        {/* Secteur */}
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={selectedSector}
            setValue={setSelectedSector}
            options={sectorDropdownOptions}
            label="Secteur d'activité"
          />
        </div>

        {/* Statut */}
        <div className={styles.item}>
          <div className={styles.label}>Statut</div>
          <div className={styles.list}>
            {statusOptions.map((status, index) => (
              <Checkbox
                className={styles.checkbox}
                content={status}
                value={selectedStatuses.includes(status)}
                onChange={() => handleStatusChange(status)}
                key={index}
                reverse
              />
            ))}
          </div>
        </div>

        {/* Boutons */}
        <div className={styles.btns}>
          <button 
            className={cn("button-stroke", styles.button)}
            onClick={resetFilters}
          >
            Réinitialiser
          </button>
          <button 
            className={cn("button", styles.button)}
            onClick={applyFilters}
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
